import { useTranslate } from "@similarweb/i18n-provider";
import { Locked, SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { StyledAddToListDropdownItem, StyledCreateListItem } from "./styles";
import type { CreateListItemProps } from "./types";

const CreateListItem = ({ clickable, onClick, isDisabled }: CreateListItemProps) => {
    const { translate } = useTranslate();

    return (
        <Tooltip
            enabled={Boolean(!clickable && isDisabled)}
            content={translate("si.components.add_to_list_dropdown.disabled.tooltip")}
        >
            <StyledCreateListItem clickable={Boolean(clickable && !isDisabled)}>
                <StyledAddToListDropdownItem
                    onClick={onClick}
                    data-automation="add-to-list-dropdown-create-item"
                    className={isDisabled ? "disabled" : ""}
                >
                    <SWReactIcons
                        iconName="add"
                        size="sm"
                    />
                    <Text
                        fontVariant="input2"
                        color={colorsPalettes.black[0]}
                    >
                        <I18n
                            data-automation="add-to-list-dropdown.create-item.text"
                            translatable={{ key: "si.components.add_to_list_dropdown.create" }}
                        />
                    </Text>
                    {isDisabled ? (
                        <Locked
                            size={24}
                            color={colorsPalettes.carbon[200]}
                        />
                    ) : null}
                </StyledAddToListDropdownItem>
            </StyledCreateListItem>
        </Tooltip>
    );
};

export default CreateListItem;
